import { Search } from '@mui/icons-material';
import { Box, CircularProgress } from '@mui/material';

export interface EmptyStateProps {
  loading: boolean;
  message: string;
}

export const EmptyState = ({ loading, message }: EmptyStateProps) =>
  loading ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <CircularProgress aria-label="loading page" />
    </Box>
  ) : (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        gap: 1,
      }}
    >
      <Search /> {message}
    </Box>
  );
